import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import qs from 'qs'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.use(ElementUI);
const log = console.log
Vue.mixin({
	data() {
		return {
            root: window.location.href.includes('localhost') ? 'api' : 'cici',
			// common option
			aVisible: false, // 显示开关1
			bVisible: false, // 显示开关2 
			cVisible: false, // 显示开关3 
			dVisible: false, // 显示开关4
			totalNum: 0, //总数
			saveType: 0, //保存类型 0新增 1编辑
			tLoading: false, //表格加载
			fLoading: false, //表单加载
            bLoading: false, //按钮加载
            importLoading: null, //按钮加载
            timeRange:'',
            imageUrl:'',
			pageData:[], //查询数据
            listData: [], //默认下拉数据
            afterCurTime: { // 今天之后
                disabledDate(time) {
                    return (time.getTime() + 24 * 60 * 60 * 1000) < Date.now();
                },
            },
            beforeCurTime: { // 今天之前
                disabledDate(time) {
                    return (time.getTime()) > Date.now();
                },
            },
            recentOptions: {
                shortcuts: [{
                    text: '最近一天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24);
                        picker.$emit('pick', [start, end]);
                    }
                },{
                    text: '最近两天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
                        picker.$emit('pick', [start, end]);
                    }
                },{
                    text: '最近三天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
                        picker.$emit('pick', [start, end]);
                    }
                },{
                    text: '最近七天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近十天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 10);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },

            uploadDataName: 'formData', //图片上传对应的表单数据名
            uploadFilePath: 'visitingCard',
            uploadUrl: "/upload",
            downloadUrl: "/download",
            sysUrl:'/dictionaries/list',
            fileUrl:""
        }
    },
    methods: {
        async request(url, para = {}, success, type = 'postJson', isLoading, error = null) {
            this.bLoading = !isLoading
            this.tLoading = !isLoading
            this.fLoading = !isLoading
            let params = new Object();
            let headers = {}
            if(sessionStorage.getItem('loginData')){
                headers = { 'username': JSON.parse(sessionStorage.getItem('loginData')).username }
            }
            if (type == 'post') params = qs.stringify(para);
            if (type == 'postJson'){
                params = para
                type = 'post';
            };
            if (type == 'get') {
                params.params = para;
                params.headers = headers;
            }
            
            await axios[type](this.root + url, params, {headers : headers}).then((res) => {
                if (res.data.code == 200) {
                    success(res.data.data)
                } else if(res.data.code == 405){
                    this.$message.error('登录超时，请重新登录')
                    this.toPage('login')
                }else {
                    this.$message({ type: 'warning', message: res.data.msg })
                }
                setTimeout(()=>{
                    this.bLoading = false
                    this.tLoading = false
                    this.fLoading = false
                },300)
            }, (res) => {
                this.$message.error('网络错误，请稍后再试')
                this.bLoading = false
                this.tLoading = false
                this.fLoading = false
            })
        },
        getPage(para = this.filters, url = this.pageUrl, pageData = 'pageData', totalNum = 'totalNum', afterFun = null) {
            this.tLoading = true;
            this.request(url, para || {}, (res) => {
                if (totalNum) {
                    this[totalNum] = res.total
                }
                this[pageData] = res.records;
                if (afterFun !== null)
                    afterFun()
            },'postJson')
        },
        searchPage() {
            this.filters.pageIndex = 1
            this.getPage()
        },
        async getList(para = {}, url = this.listUrl, dataName = 'listData', afterFun = null) {
            await this.request(url, para || {}, (res) => {
                this[dataName] = res;
                if (afterFun !== null)
                    afterFun(res)
            }, 'post', true)
        },
        setStoreData(url, para, setName){
            this.request(url , para, (data) => {
				this.$store.commit(setName, data)
			})
		},

        handleForm(type, row, afterFun = null) {
            this.aVisible = true;
            this.$nextTick(() => {
                this.$refs.formFileds.resetFields();
                if (this.$refs.upload) {
                    this.$refs.upload.clearFiles();
                    this.fileList = [];
                }
                if (type) {
                    this.saveType = 1
                    this.formData.id = row.id
                    this.mergeObject(this.formData, row)
                    if (afterFun !== null)
                    afterFun(row)
                } else {
                    this.saveType = 0
                    delete this.formData.id
                }
            })
        },

        //新增编辑保存
        formSubmit(url = this.addUrl, para = this.formData, afterFun = this.getPage) {
            this.$refs.formFileds.validate((valid) => {
                if (valid) {
                    this.$confirm('确认保存或提交吗？', '提示', {}).then(() => {
                        this.bLoading = true
                        this.request(url, para, (data) => {
                            this.$message({ message: '保存或提交成功', type: 'success' })
                            this.aVisible = false
                            if (afterFun !== null)
                                afterFun()
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        });
                    })
                }
            })
        },

        //删除
        handleDel(row, para, url = this.deleteUrl, afterFun = this.getPage) {
            this.$confirm('确认删除该记录吗?', '提示', {
                type: 'warning'
            }).then(() => {
                this.bLoading = true
                this.request(url, para || { id: row.id }, (data) => {
                    this.$message({ message: '删除成功', type: 'success' })
                    if (afterFun !== null)
                        afterFun()
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            })
        },
        
        toBack(){
            this.$router.go(-1);
        },

        toPage(path, query={}){
            this.$router.push({ path: '/' + path, query: query })
        },

        handleCurrentChange(val, filters = this.filters, afterFun = this.getPage) {
            filters.pageIndex = val
            afterFun()
        },

        //图片处理逻辑-下面三个方法所有上传组件通用
        handleSuccess(file,fileList, uploadFilePath) {
            if (file.code == "200") {
                // this.imageUrl = URL.createObjectURL(file.raw);
                this.$message.success("上传成功");
                this[this.uploadDataName][this.uploadFilePath] = file.data;
                this.fileList.push({
                    name: file.data,
                    url: this.fileUrl + file.data
                })
            }
        },
        handleRemove(file) {
            this.fileList = this.fileList.filter(item=>item.name != file.name)
            this[this.uploadDataName][this.uploadFilePath] = '';
        },
        
        // 数据替换
        mergeObject(a, b) {
            for (let k in a) {
                a[k] = b[k] == null || b[k] == undefined || b[k] == '' ? a[k] : b[k];
            }
            return a;
        },
        sortChange(column){
            if(column.order){
                this.filters.pageSorts = [];
                let o = { column: column.prop, asc: column.order == 'descending' ? false : true }
                this.filters.pageSorts.push(o)
            }else{
                this.filters.pageSorts = null
            }
            this.getPage()
        },
        getTimeRange(val,start,end){
            this.filters[start] = val ? val[0] : ''
            this.filters[end] = val ? val[1] : ''
        },
        
        handleExport(param = this.filters){
            this.request(this.exportUrl, param, data=>{
                if(data){
                    window.open(data)
                }else{
                    this.$message.warning('导出失败')
                }
            })
        },
        handleExportTemplate(){
            this.request(this.exportTemplateUrl, {}, data=>{
                if(data){
                    window.open(data)
                }else{
                    this.$message.warning('导出失败')
                }
            })
        },
        importSuccess(file) {
            if (file.code == "200") {
                this.request(this.importUrl , { fileName:file.data }, (data) => {
                    this.$message.warning('导入成功')
                    this.getPage()
                    if(this.importLoading) this.importLoading.close()
                })
            }
        },
        beforeImportFile(file) {
            if (!file.name.includes('xls')) {
                this.$message.warning('只能上传excel文件')
                return
            }
            this.importLoading = this.$loading({
                lock: true,
                text: '文件导入中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        },
        handleError() {
            this.$message.warning('上传失败')
            if(this.importLoading) this.importLoading.close()
        },
    },
})


new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})